import { __rest } from "tslib";
import React from 'react';
import BodyText from '../BodyText';
const MetaText = (_a) => {
    var { Tag = 'span', className, children } = _a, props = __rest(_a, ["Tag", "className", "children"]);
    return (React.createElement(BodyText, Object.assign({ Tag: Tag, className: className, meta: true }, props), children));
};
export default MetaText;
//# sourceMappingURL=MetaText.js.map